import { FC } from 'react';
import { ErrorTemplateRed } from '@/components/ErrorTemplate';
import { FundCompositionPieChartLayout } from './components/FundCompositionPieChartLayout';
import { useGetFundDetailsData } from '../../../../hooks/useGetFundDetailsData';
import { FundCompositionPieChart } from './FundCompositionPieChart';
import { FundCompositionPieChartSkeleton } from './FundCompositionPieChart.skeleton';

export const FundCompositionPieChartWrapper: FC = () => {
  const { data, isLoading, isError, error, refetch, isFetching } =
    useGetFundDetailsData();

  if (isLoading) {
    return <FundCompositionPieChartSkeleton />;
  }

  if (isError) {
    return (
      <FundCompositionPieChartLayout>
        <ErrorTemplateRed
          className="h-[208px]"
          errorMessage={error?.message}
          isLoading={isFetching}
          onRefetch={refetch}
        />
      </FundCompositionPieChartLayout>
    );
  }

  if (data?.assetCompesitions.length === 0) {
    return null;
  }

  return (
    <FundCompositionPieChartLayout>
      <FundCompositionPieChart />
    </FundCompositionPieChartLayout>
  );
};
